import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';

export default class EventService extends ApiService {
  public getGlobalEvents(options) {
    return this.call(new ApiGetOptions(
      {
        url: '/global_events',
        params: options,
      },
    ));
  }
}
